import { store } from "@betacrew/jars-flux";
import General from "../../../../libs/utility/General";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { componentKey, setBackEndConfigSettings, setCountriesList, setFormCategory, setFormsScheduleDates, setGlobalFormsNYearsList, setPrepayAmount, setPurchasePlanDetails, setStatesList, setforms94xList, updateDataLoadingState } from "./DataLoaderSlice";
import { all, call, put, takeLeading } from "redux-saga/effects";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import { PAGE_STATE } from "../../constants/constants";
import GeneralDataService from "../../../../services/GeneralDataService";
import PaymentDataService from "../../../../services/PaymentDataService";
import { DATA_LOADER_LOADING_STATES, GET_SCHEDULED_DATE_DATA } from "./constants";
import SubmitFormsDataService from "../../../../services/SubmitFormsDataService";
import FormsDataService from "../../../../services/FormsDataService";
import HistoryDataService from "../../../../services/HistoryDataService";
import DataLoaderDataService from "../../../../services/DataLoaderDataService";

export const { getCountriesAndStatesList, getPrepayAmount, getGlobalFormsList, getforms94xList, getScheduledDateDeadlines, getConfigSettings } = {
    getCountriesAndStatesList: (payload) => {
        return {
            type: "DATALOADER/GET_COUNTRIES_AND_STATES_LIST",
            payload
        }
    },
    getPrepayAmount: (payload) => {
        return {
            type: "DATALOADER/GET_PREPAY_AMOUNT",
            payload
        }
    },
    getGlobalFormsList: (payload) => {
        return {
            type: "DATALOADER/GET_GLOBAL_FORMS_LIST",
            payload
        }
    },
    getforms94xList: (payload) => {
        return {
            type: "DATALOADER/GET_FORMS_94X_LIST",
            payload
        }
    },
    getScheduledDateDeadlines: (payload) => {
        return {
            type: "DATALOADER/SCHEDULE_DATE_DEADLINES",
            payload
        }
    },
    getConfigSettings: (payload) => {
        return {
            type: "DATALOADER/CONFIG_SETTINGS",
            payload
        }
    },
}

function* getCountriesAndStatesAsync(action) {

    try {
        yield put(updateDataLoadingState({ state: PAGE_STATE.LOADING, message: "Fetching Data..." }))

        const [countriesResponse, statesResponse] = yield all([
            call(GeneralDataService.getCountries),
            call(GeneralDataService.getStates),
        ]);


        let countriesList = [];
        let statesList = [];

        if (countriesResponse.data.Status) {
            countriesList = countriesResponse.data.Data;
            General.addOptionAndValueKeys(countriesList, "Country_Name", "Country_code")
        } else {
            yield put(addNotifications({ heading: "Failed to get the countries", variant: TOASTER_VARIANT.DANGER }));
        }

        if (statesResponse.data.Status) {
            statesList = statesResponse.data.Data;
            General.addOptionAndValueKeys(statesList, "StateName", "StateAbbreviation")
        } else {
            yield put(addNotifications({ heading: "Failed to get the states", variant: TOASTER_VARIANT.DANGER }));
        }

        yield put(setCountriesList(countriesList));
        yield put(setStatesList(statesList));

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get states and countries", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(updateDataLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* getPrepayAmountAsync(action) {
    try {
        yield put(updateDataLoadingState({ state: PAGE_STATE.LOADING, message: "Fetching Prepay Amount" }));

        const response = yield PaymentDataService.getPrepaidAmount();

        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setPrepayAmount(Data));
        } else {
            yield put(addNotifications({ heading: "Failed to get the Prepaid Amount", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the Prepaid Amount", message: error?.response?.data?.Message }));
    } finally {
        yield put(updateDataLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* getGlobalFormsListAsync(action) {
    try {
        yield put(updateDataLoadingState({ state:  DATA_LOADER_LOADING_STATES.GET_GLOBAL_FORMS_LIST_LOADING}));
        const response = yield FormsDataService.getFormsList();
        if(response){
            if(response?.data?.Status === 1){
                const formsObject = {};
                for (const form of response?.data?.Data?.Forms) {
                    formsObject[form.Id] = form;
                }
                yield put(setGlobalFormsNYearsList({
                    Forms: formsObject,
                    Years: response?.data?.Data?.Years,
                }));
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(updateDataLoadingState({ state: DATA_LOADER_LOADING_STATES.GET_GLOBAL_FORMS_LIST_READY }))
    }
}

function* getforms94xListAsync(action) {
    try {
        yield put(updateDataLoadingState({ state:  DATA_LOADER_LOADING_STATES.GET_GLOBAL_FORMS_94X_LIST_LOADING}));
        const response = yield HistoryDataService.get94XFormList();
        if(response){
            if(response?.data?.Status === 1){
                const forms94xListObj = {};
                response?.data?.Data.forEach((str) => {
                    forms94xListObj[str] = str;
                });

                yield put(setFormCategory(response.data.Data))
                yield put(setforms94xList(forms94xListObj));
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(updateDataLoadingState({ state: DATA_LOADER_LOADING_STATES.GET_GLOBAL_FORMS_94X_LIST_READY }))
    }
}

function* getScheduledDateDeadlinesAsync(action) {
    try {
        yield put(updateDataLoadingState({ state: DATA_LOADER_LOADING_STATES.GET_SCHEDULED_DATE_DEADLINES_LOADING }));

        const response = yield SubmitFormsDataService.getScheduledDates();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setFormsScheduleDates(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the schedule dates deadline", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the schedule dates deadline", message: error?.response?.data?.Message }));
    } finally {
        yield put(updateDataLoadingState({ state: DATA_LOADER_LOADING_STATES.GET_SCHEDULED_DATE_DEADLINES_READY }))
    }
}

function* getConfigSettingsAsync(action){
    try {
        yield put(updateDataLoadingState({ state: DATA_LOADER_LOADING_STATES.GET_CONFIG_SETTINGS_LOADING }));

        const response = yield DataLoaderDataService.getConfig();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setBackEndConfigSettings(Data))
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(updateDataLoadingState({ state: DATA_LOADER_LOADING_STATES.GET_CONFIG_SETTINGS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLeading(getCountriesAndStatesList().type, getCountriesAndStatesAsync),
        takeLeading(getPrepayAmount().type, getPrepayAmountAsync),
        takeLeading(getGlobalFormsList().type, getGlobalFormsListAsync),
        takeLeading(getforms94xList().type, getforms94xListAsync),
        takeLeading(getScheduledDateDeadlines().type, getScheduledDateDeadlinesAsync),
        takeLeading(getConfigSettings().type, getConfigSettingsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);